import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryStudents } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryStudents } from "@/api/members/laboratories/students/getAll";
import { useGetMemberLaboratoryStudent } from "@/api/members/laboratories/students/get";

const { getPath } = getApi("members.laboratories.students.put");

type IExtractedRouteType = ILaboratoryStudents["laboratoryStudentSingleUpdate"];

export type IPutMemberLaboratoryStudent = IPickMutation<IExtractedRouteType>;

const putMemberLaboratoryStudent: MutationFunction<
  IPutMemberLaboratoryStudent["response"],
  IPutMemberLaboratoryStudent["variables"]
> = ({ labId, studentId, ...data }) => {
  return axiosClient.put(getPath({ labId, studentId }), data);
};

export const usePutMemberLaboratoryStudent = createMutation({
  mutationFn: putMemberLaboratoryStudent,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryStudents.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryStudent.getKey({ labId }),
    });
  },
});
